import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
}))
@observer
class NewBroadcastDaySchedule extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('broadcastDaySchedule'),
        };
    }

    createBroadcastDaySchedule = async () => {
        const { callback = () => {} } = this.props;
        const { broadcastScheduleStore } = this.props.stores;
        const { newBroadcastDaySchedule } = broadcastScheduleStore;
        const response = await broadcastScheduleStore.adminCreate(newBroadcastDaySchedule);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { broadcastScheduleStore } = this.props.stores;
        if (!isNew) {
            broadcastScheduleStore.adminSetFromId(id);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, broadcastScheduleStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newBroadcastDaySchedule } = broadcastScheduleStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <h5 class='ms-3 mb-3'>
                        {isNew ? 'New Broadcast Day Schedule' : 'Edit Broadcast Day Schedule'}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={broadcastScheduleStore} objectName={isNew ? 'newBroadcastDaySchedule' : 'broadcastDaySchedule'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createBroadcastDaySchedule}>
                            {isNew ? 'Create Broadcast Day Schedule' : 'Save Broadcast Day Schedule'}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewBroadcastDaySchedule;
